(function () {
	let swiperMulticolumn;
	const multicolumnSwipeEnabled = document.querySelector('.swiper--multicolumn');

	if (!multicolumnSwipeEnabled) return;

	const initSlider = () => {
		multicolumnSwipeEnabled.classList.add('multicolumn-swiper-wrapper');
		const slides = document.querySelectorAll('.multicolumn-list__item');

		slides.forEach((slide) => {
			slide.classList.add('swiper-slide');
		});

		const mobilePerView = parseInt(multicolumnSwipeEnabled.dataset.mobilePerView) || 1;
		const autoplay = multicolumnSwipeEnabled.dataset.autoplay === 'true';
		const autoplayDelay = (parseInt(multicolumnSwipeEnabled.dataset.autoplayDelay) || 2) * 1000;

		const swiperConfig = {
			loop: true,
			slidesPerView: mobilePerView,
			spaceBetween: 16,
		};

		if (autoplay) {
			swiperConfig.autoplay = {
				delay: autoplayDelay,
				disableOnInteraction: false,
			};
		}

		swiperMulticolumn = new Swiper('.swiper--multicolumn', swiperConfig);
	};

	const destroySlider = () => {
		multicolumnSwipeEnabled.classList.remove('multicolumn-swiper-wrapper');
		const slides = document.querySelectorAll('.multicolumn-list__item');

		swiperMulticolumn.destroy(true, true);
		swiperMulticolumn = undefined;

		slides.forEach((slide) => {
			slide.removeAttribute('style');
			slide.classList.remove('swiper-slide');
		});
	};

	const initMulticolumn = () => {
		const multicolumnSection = document.querySelector('.multicolumn-section');

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 576) {
				initSlider();
			} else if (swiperMulticolumn) {
				destroySlider();
			}
		});

		sectionResizeObserver.observe(multicolumnSection);
	};

	if (swiperMulticolumn) {
		destroySlider();
	}
	initMulticolumn();
	document.addEventListener('shopify:section:load', function () {
		if (swiperMulticolumn) {
			destroySlider();
		}
		initMulticolumn();
	});
})();
